export default "__VITE_ASSET__c5a3d9e5__"